import React, {useEffect} from "react";

import settings from "../settings.json";

export default function SiteHandler({active}: any) {
    useEffect(() => {
        document.title = settings.site_title + " - " + active.title;
    }, [active]);
    return (
        <div>
            {active.component}
        </div>
    );

}